import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SelectOption = (props) => {
  function renderBackgroundColor(isFocused, isSelected) {
    if (isFocused) {
      return 'var(--cc_color_brand_primary)';
    } else if (isSelected) {
      return 'var(--cc_color_background_2)';
    } else {
      return 'var(--cc_color_background_1)';
    }
  }

  const StyledOption = styled.div`
    cursor: pointer;
    padding: 12px 16px;
    background-color: ${() =>
      renderBackgroundColor(props.isFocused, props.isSelected)};
  `;

  const OptionSecondary = styled.div`
    font-size: 14px;
    color: ${() =>
      props.isFocused
        ? 'var(--cc_color_button_text_primary)'
        : 'var(--cc_color_text_subtle)'};
  `;

  const OptionPrimary = styled.div`
    font-size: 16px;
    color: ${() =>
      props.isFocused
        ? 'var(--cc_color_button_text_primary)'
        : 'var(--cc_color_text_default)'};
    + ${OptionSecondary} {
      margin-block-start: 4px;
    }
  `;

  return (
    <StyledOption
      ref={props.innerRef}
      {...props.innerProps}
      isFocused={props.isFocused}
      isSelected={props.isSelected}
    >
      <OptionPrimary isFocused={props.isFocused} isSelected={props.isSelected}>
        {props.primaryDescription}
      </OptionPrimary>
      <OptionSecondary
        isFocused={props.isFocused}
        isSelected={props.isSelected}
      >
        {props.secondaryDescription}
      </OptionSecondary>
    </StyledOption>
  );
};

SelectOption.propTypes = {
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  primaryDescription: PropTypes.string,
  secondaryDescription: PropTypes.string,
  innerRef: PropTypes.func,
  innerProps: PropTypes.object,
};

export default SelectOption;
